import React, { useState } from 'react';
import { IOptionType } from '../helpers/typings';
import { Button, Col, Form, Row } from 'react-bootstrap';
import { v4 as uuidv4 } from 'uuid';
import CaptainModal from '../../../Components/CaptainModal';

type OptionFormProps = {
    isOpen: boolean;
    onClose: () => void;
    option: IOptionType;
    setOption: (option: IOptionType) => void;
    onSave: (option: IOptionType) => void;
};

const OptionForm: React.FC<OptionFormProps> = ({
    isOpen,
    onClose,
    option,
    setOption,
    onSave,
}) => {
    const handleSubmit = (e: any) => {
        e.preventDefault();
        if (!option?.id) {
            option.id = uuidv4();
        }
        onSave(option);
    };

    const handleChange = (key: string) => {
        return (e: any) => {
            setOption({
                ...option,
                [key]: e.target.value,
            });
        };
    };

    const handleTypeChange = (key: string) => {
        return (e: any) => {
            setOption({
                ...option,
                type: {
                    ...option.type,
                    [key]: e.target.value,
                },
            });
        };
    };
    return (
        <CaptainModal
            isOpen={isOpen}
            onClose={onClose}
            style={{ backgroundColor: 'rgba(0, 0, 0, 0.1)' }}
        >
            <div>
                <Form onSubmit={handleSubmit} className="mx-3 pt-2">
                    <div className="text-center fw-bold fs-4 mb-2">
                        {option.id ? 'Edit Option' : 'Add Option'}
                    </div>
                    <Form.Group className="mb-3">
                        <Form.Label>Value:</Form.Label>
                        <Form.Control
                            type="text"
                            required
                            value={option.value}
                            onChange={handleChange('value')}
                        />
                    </Form.Group>

                    <Form.Group className="mb-3">
                        <Form.Label>Rank:</Form.Label>
                        <Form.Control
                            type="number"
                            required
                            value={option.rank}
                            onChange={handleChange('rank')}
                        />
                    </Form.Group>

                    <Form.Group className="mb-3">
                        <Form.Label>Category:</Form.Label>
                        <Form.Select
                            value={option.type.category}
                            required
                            onChange={handleTypeChange('category')}
                        >
                            <option value="mcq">MCQ</option>
                            <option value="sort">Sort</option>
                            <option value="rating">Rating</option>
                            <option value="input">Input</option>
                            <option value="checkbox">Checkbox</option>
                        </Form.Select>
                    </Form.Group>

                    {option.type.category === 'mcq' && (
                        <>
                            <Form.Group className="mb-3">
                                <Form.Label>Subcategory</Form.Label>
                                <Form.Select
                                    value={option.type.subCategory || ''}
                                    onChange={handleTypeChange('subCategory')}
                                >
                                    <option value="basic">Basic</option>
                                    <option value="image">Image</option>
                                    <option value="input">Input</option>
                                </Form.Select>
                            </Form.Group>

                            <Form.Group className="mb-3">
                                <Form.Label>Selection Type</Form.Label>
                                <Form.Select
                                    value={option.type.selectionType || ''}
                                    onChange={handleTypeChange('selectionType')}
                                >
                                    <option value="single">Single</option>
                                    <option value="multi">Multi</option>
                                </Form.Select>
                            </Form.Group>
                        </>
                    )}

                    {option.type.category === 'rating' && (
                        <>
                            <div className="mb-3 fw-semibold">Range:</div>
                            <Row className="mb-2">
                                <Col>
                                    <Form.Label>
                                        Min Value (Optional):
                                    </Form.Label>
                                    <Form.Control
                                        type="text"
                                        value={option.range?.min?.value || ''}
                                        onChange={e =>
                                            setOption({
                                                ...option,
                                                range: {
                                                    ...option.range,
                                                    min: {
                                                        ...option.range?.min,
                                                        value: e.target.value,
                                                    },
                                                },
                                            })
                                        }
                                    />
                                </Col>
                                <Col>
                                    <Form.Label>Min Unit:</Form.Label>
                                    <Form.Control
                                        type="number"
                                        required
                                        value={option.range?.min?.unit || ''}
                                        onChange={e =>
                                            setOption({
                                                ...option,
                                                range: {
                                                    ...option.range,
                                                    min: {
                                                        ...option.range?.min,
                                                        unit: parseInt(
                                                            e.target.value,
                                                        ),
                                                    },
                                                },
                                            })
                                        }
                                    />
                                </Col>
                            </Row>

                            <Row className="mb-3">
                                <Col>
                                    <Form.Label>
                                        Max Value (Optional):
                                    </Form.Label>
                                    <Form.Control
                                        type="text"
                                        value={option.range?.max?.value || ''}
                                        onChange={e =>
                                            setOption({
                                                ...option,
                                                range: {
                                                    ...option.range,
                                                    max: {
                                                        ...option.range?.max,
                                                        value: e.target.value,
                                                    },
                                                },
                                            })
                                        }
                                    />
                                </Col>
                                <Col>
                                    <Form.Label>Max Unit:</Form.Label>
                                    <Form.Control
                                        type="number"
                                        required
                                        value={option.range?.max?.unit || ''}
                                        onChange={e =>
                                            setOption({
                                                ...option,
                                                range: {
                                                    ...option.range,
                                                    max: {
                                                        ...option.range?.max,
                                                        unit: parseInt(
                                                            e.target.value,
                                                        ),
                                                    },
                                                },
                                            })
                                        }
                                    />
                                </Col>
                            </Row>
                        </>
                    )}

                    <Button type="submit" className="w-100">
                        save
                    </Button>
                </Form>
            </div>
        </CaptainModal>
    );
};

export default OptionForm;
